"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornUseCase = void 0;
require("reflect-metadata");
var ioc_1 = require("../ioc");
var mobx_1 = require("mobx");
var inversify_1 = require("inversify");
var GeneratorConstructor = function () { return __generator(this, function (_a) {
    return [2 /*return*/];
}); }.constructor;
var AcornUseCase = /** @class */ (function () {
    function AcornUseCase() {
    }
    Object.defineProperty(AcornUseCase, "create", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return ioc_1.getCoreContainer().resolve(this);
        }
    });
    Object.defineProperty(AcornUseCase.prototype, "execute", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.onExecute instanceof GeneratorConstructor) {
                // If it's a generator, pass it to flow to return a promise which
                // resolves to T
                /**
                 * ts-ignore required here as TypeScript can't tell that
                 * `this.executeImplementation` is a generator function without a
                 * bit of a workaround.
                 */
                // @ts-ignore
                return mobx_1.flow(this.onExecute.bind(this)).apply(void 0, args);
            }
            else {
                // If it's not a generator, we can just execute it.
                // ts-ignore here for the same reason as above
                // @ts-ignore
                return mobx_1.runInAction(function () {
                    return _this.onExecute.apply(_this, args);
                });
            }
        }
    });
    AcornUseCase = __decorate([
        inversify_1.injectable()
    ], AcornUseCase);
    return AcornUseCase;
}());
exports.AcornUseCase = AcornUseCase;
//# sourceMappingURL=AcornUseCase.js.map